import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import { useColorMode } from '../theme/ColorModeProvider';

/** Sun/moon switch that flips between the dark (default) and light themes. */
export default function ColorModeToggle({ color = 'inherit' }: { color?: 'inherit' | 'primary' | 'default' }) {
    const { mode, toggleColorMode } = useColorMode();
    const toLight = mode === 'dark';
    const label = toLight ? 'Switch to light mode' : 'Switch to dark mode';

    return (
        <Tooltip title={label}>
            <IconButton onClick={toggleColorMode} aria-label={label} color={color} size="small">
                {toLight ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </Tooltip>
    );
}
